'use strict';

var _require = require('lodash'),
    get = _require.get,
    isEqual = _require.isEqual,
    pick = _require.pick;

var _require2 = require('./constants/post'),
    POST_DRAFT_FIELDS = _require2.POST_DRAFT_FIELDS;

var toDate = require('./utils/to-date');

var _require3 = require('./utils/date-utils'),
    isAfter = _require3.isAfter;

var POST_LOCK_MINUTES = 10;
var MS_PER_MINUTE = 60000;

var isAnotherWriterEditingThePost = function isAnotherWriterEditingThePost() {
  var post = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentUserId = arguments[1];

  if (!post.lastWriterId) {
    return false;
  }

  if (currentUserId === post.lastWriterId || currentUserId === post.lastWriterSiteMemberId) {
    return false;
  }

  var now = new Date();
  var lockedAt = new Date(now.getTime() - POST_LOCK_MINUTES * MS_PER_MINUTE);
  var editedAt = get(post, 'draft.editedDate');

  return isAfter(editedAt, lockedAt) && !isAfter(post.lastPublishedDate, editedAt);
};

var isPublished = function isPublished(post) {
  return get(post, 'status') === 'published';
};

var isScheduled = function isScheduled(post) {
  return get(post, 'status') === 'scheduled';
};

var pickDraftProps = function pickDraftProps(post) {
  return pick(post, POST_DRAFT_FIELDS);
};

var hasUnpublishedChanges = function hasUnpublishedChanges() {
  var post = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return isPublished(post) && !isEqual(pickDraftProps(post), pickDraftProps(post.draft));
};

var getTime = function getTime(date) {
  return toDate(date).getTime();
};
var isEdited = function isEdited(post) {
  return getTime(post.firstPublishedDate) !== getTime(post.lastPublishedDate);
};

module.exports = {
  isAnotherWriterEditingThePost: isAnotherWriterEditingThePost,
  hasUnpublishedChanges: hasUnpublishedChanges,
  pickDraftProps: pickDraftProps,
  isPublished: isPublished,
  isScheduled: isScheduled,
  isEdited: isEdited
};